import { TextVariant } from "@/core/components/Field/Text";
import { HeadingLevel } from "@/core/types/types";
import { CircularProgress, Theme } from "@mui/material";

interface LoadingTextProps {
  loading: boolean;
  theme: Theme;
  text: string;
}

const LoadingText: React.FC<LoadingTextProps> = ({ loading, theme, text }) => {
  return loading ? (
    <CircularProgress
      size={20}
      style={{ margin: theme.spacing(1), color: theme.palette.grey[800] }}
    />
  ) : (
    <TextVariant
      variant={HeadingLevel.Body1}
      color={theme.palette.grey[800]}
      text={text}
    />
  );
};

export { LoadingText };
